import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ModalContainer = _resolveComponent("ModalContainer")!
  const _component_CookieBanner = _resolveComponent("CookieBanner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (_ctx.showToast)
      ? (_openBlock(), _createBlock(_component_Toast, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createBlock(_component_ModalContainer, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_CookieBanner, {
      visible: _ctx.showCookieBanner,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showCookieBanner) = $event)),
      onAccept: _ctx.onCookieAccept,
      onRefuse: _ctx.onCookieRefuse,
      onSave: _ctx.onCookieSave
    }, null, 8, ["visible", "onAccept", "onRefuse", "onSave"])
  ]))
}